import Logo from "../components/Logo";
import { CONTACT } from "../data";

export default function Footer() {
  return (
    <footer className="border-t border-stone-300 bg-[#EFEAE0]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-12">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="flex flex-col items-start gap-3">
            <Logo height={64} className="self-start" />
            <p className="text-[11px] font-tech uppercase tracking-[0.18em] text-stone-600" data-testid="footer-tagline">
              Aluminium Pressure Die Casting | Precision Components | Custom Product Development
            </p>
          </div>
          <div className="flex flex-col lg:items-end gap-1 text-sm text-stone-600">
            <span>{CONTACT.address}</span>
            <a href={`tel:${CONTACT.phone1}`} className="hover:text-amber-700 transition-colors">
              {CONTACT.phone1}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="hover:text-amber-700 transition-colors break-all">
              {CONTACT.email}
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-stone-300 pt-6">
          <p className="text-xs text-stone-500">
            © {new Date().getFullYear()} SK Engineering Works. All rights reserved.
          </p>
          <p className="text-xs font-tech uppercase tracking-[0.18em] text-stone-500">
            Manufactured in Delhi, India
          </p>
        </div>
      </div>
    </footer>
  );
}
